import NavLinkAdapter from '@fuse/core/NavLinkAdapter';
import Typography from '@mui/material/Typography';
import { NavLink } from "react-router-dom";
import generateChannelUrl from "app/shared-components/channel/utils/generateChannelUrl";

function ChannelName(props) {
  let { channel, className, color, disableClick, mode} = props;
  const useClasses= className ? className : "text-sm font-medium";
  const useColor= color ? color : "text.secondary";
  const isPublic= mode == "public";
  const type= channel?.type;
  const pathToChannel = generateChannelUrl(channel, isPublic);
  const name= channel?.entity?.name ? channel.entity.name : channel?.name;

  if (!name) return null;
  if (type !== 'team' && type !== 'group' && type !== 'organization') return null;

  
  return (

        <Typography className={useClasses} color={useColor}>
        {disableClick ? name :
          <NavLink to={pathToChannel}  style={{ textDecoration: 'none', color: useColor }}>{name}</NavLink>
        }
        </Typography>

  );
  
}

 
export default ChannelName;